import { render, staticRenderFns } from "./related-lessons.vue?vue&type=template&id=e7a6ee66&scoped=true"
import script from "./related-lessons.vue?vue&type=script&lang=js"
export * from "./related-lessons.vue?vue&type=script&lang=js"
import style0 from "./related-lessons.vue?vue&type=style&index=0&id=e7a6ee66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7a6ee66",
  null
  
)

export default component.exports